import { useEffect, useState } from 'react'
import khoaThiProcessor from '../../processor/khoaThiProcessor'
import namProcessor from '../../processor/namProcessor'
import DonViDangKyDuThi from './Components/DonViDangKyDuThi'
import ThayDoiCauHinhBanChinh from './Components/ThayDoiCauHinhBanChinh'

const CauHinhBanChinh = () => {
  const [danhSachBanChinh, setDanhSachBanChinh] = useState([])
  const [namId, setNamId] = useState(0)
  const [khoaThiId, setKhoaThiId] = useState(0)
  const [listNam, setListNam] = useState([])
  const [listKhoaThi, setListKhoaThi] = useState([])

  const getNam = async () => {
    const rs = await namProcessor.getAll()
    setListNam(rs)
    if (rs.length > 0) {
      setNamId(rs[0].id)
    }
  }

  const getKhoaThi = async () => {
    if (namId) {
      const rs = await khoaThiProcessor.getByNam(namId)
      if (rs.length > 0) {
        setKhoaThiId(rs[0].id)
      }
      setListKhoaThi(rs)
    }
  }
  useEffect(getNam, [])
  useEffect(getKhoaThi, [namId])

  return (
    <div className="grid">
      <div className="col-12">
        <ThayDoiCauHinhBanChinh
          datas={danhSachBanChinh}
          setDatas={setDanhSachBanChinh}
          namId={namId}
          setNamId={setNamId}
          khoaThiId={khoaThiId}
          setKhoaThiId={setKhoaThiId}
          listNam={listNam}
          listKhoaThi={listKhoaThi}
        />
      </div>
      <div className="col-12 lg:col-6">
        {
          // <HoiDong listKhoaThi={listKhoaThi} listNam={listNam} khoaThiId={khoaThiId} namId={namId} />
        }
      </div>
      <div className="col-12 lg:col-12">
        <DonViDangKyDuThi
          listKhoaThi={listKhoaThi}
          listNam={listNam}
          khoaThiId={khoaThiId}
          namId={namId}
        />
      </div>
    </div>
  )
}

export default CauHinhBanChinh
